// extracted by mini-css-extract-plugin
export var buttonContent = "_3c-0";
export var centered = "_3c-1";
export var centeredFlex = "_3c-2";
export var errorText = "_3c-3";
export var icon = "_3c-4";
export var iconButtonContent = "_3c-5";
export var monospace = "_3c-6";
export var padded = "_3c-7";